@if (file) {
  <div class="file-card {{ isSelected(file!) && selectable ? 'selected' : '' }} d-flex flex-column justify-content-between overflow-hidden">
    <div class="file-icon-section position-relative d-flex align-items-center justify-content-center">
      @if (file!.type !== 'file' && file!.preview) {
        <img [ngSrc]="file!.preview" [width]="150" [height]="100" [sizes]="'100vw, 100vw, 100vw'" [alt]="file!.filename" priority="low" class="file-image" />
      }
      @if (file!.type !== 'file' && file!.type === 'image') {
        <img [ngSrc]="file!.path!" [width]="150" [height]="100" [sizes]="'100vw, 100vw, 100vw'" [alt]="file!.filename" priority="low" class="file-image" />
      }
      @if (file!.type !== 'file') {
        <div class="image-preview-overlay" (click)="selectDocument(file!)"></div>
      }
      @if (file!.type === 'file') {
        <div class="fileIcons" (click)="selectDocument(file!)">
          <div class="file-icon-container" [class]="documentService.getDocumentClass(file!)">
            <span class="fileIconBase mts-icon mts-icon-filled fs-l lh-base">insert_drive_file</span>
            <div class="file-type">{{ documentService.getDocumentExtension(file!) }}</div>
          </div>
        </div>
      }
      <app-tooltip [type]="'File'" [opensOn]="'Auto'" [file]="file" [icon]="'info'" [cssClass]="'p-2'"></app-tooltip>
      @if (file!.type !== 'file') {
        <div class="position-absolute top-0 end-0 me-2 me-sm-1 mt-1 mt-sm-0 icons" (click)="openGallery(file!)">
          <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'visibility'"></app-icon-badge>
        </div>
      }
      @if (file!.type === 'image') {
        <div class="position-absolute top-0 start-0 ms-1 mt-1">
          <app-icon-badge
            [style]="'default'"
            [fontSize]="'fs-5'"
            [fontColor]="'text-white'"
            [icon]="!file!.could_be_fallback ? 'label_off' : (file!.fallback ? 'label_important' : 'label')"
          ></app-icon-badge>
        </div>
      }
      @if (file!.type === 'file') {
        <div class="position-absolute top-0 end-0 me-2 me-sm-1 mt-1 mt-sm-0 icons" (click)="documentService.openDocument(file!)">
          <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [fontColor]="'text-white'" [icon]="'visibility'"></app-icon-badge>
        </div>
      }
      <div class="position-absolute bottom-0 end-0 me-2 me-sm-1 mb-1 mb-sm-0 icons selected-icon">
        <app-icon-badge [style]="'default'" [fontSize]="'fs-5'" [icon]="'task_alt'"></app-icon-badge>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center flex-grow-1 px-2 py-1" (click)="selectDocument(file!)">
      <span class="truncate-text-two-lines text-center overflow-hidden fs-small text-muted">{{ file!.filename }}</span>
    </div>
  </div>
}
